import React, { useState, useEffect, useCallback, useMemo } from "react";
import Layout from "./Shared/Layout";
import { get, post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { decryptData } from "../_services/encDnc";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import UserAddress from "./Shared/UserAddress";
import { get_cart_Data } from "../redux/action";
import AddressForm from "./Shared/AddressForm";
import Summary from "./Shared/Summary";

const ShippingAddress = () => {
    const loginId = localStorage.getItem('loginId');
    const [userAddress, setUserAdderss] = useState([]);
    const [loginDetailById, setLognDetailById] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [stateData, setStateData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saveloading, setSaveloading] = useState(false);
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail'));
    const existingCartItemDetail = JSON.parse(localStorage.getItem('cartItemDetail'));
    const [selectedAddressId, setSelectedAddressId] = useState(0)
    const [totalAmounts, setTotalAmounts] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        addressId: 0,
        loginId: loginId,
        addressTypeId: 1,
        name: loginDetailById.name || "",
        addressLine1: "",
        addressLine2: "",
        landmark: "city",
        city: "",
        stateId: 0,
        countryId: 1,
        pincode: "",
        emailId: loginDetailById.emailId || "",
        contatctNo: String(loginDetailById.mobileNo || ""),
        isActive: true,
    });

    const [cartData, setCartData] = useState([]);
    const reduxCartData = useSelector((state) => state.cartReducer.cart);
    const deliveryCharge = 0.00;

    const cartItems = useMemo(() => {
        return reduxCartData.map(item => ({
            cartItemId: item.cartItemId || 0,
            productId: item.productId || 0,
            loginId: loginId ? Number(loginId) : 0,
            buyStatus: item.buyStatus || 0,
            quantity: item.quantity || 1,
            unitPrice: item.unitPrice || 0,
            totalAmount: item.unitPrice ? item.unitPrice * item.quantity : 0
        }));
    }, [reduxCartData, loginId]);

    useEffect(() => {
        const items = existingItemDetails?.length > 0
            ? existingItemDetails
            : existingCartItemDetail?.length > 0
                ? existingCartItemDetail
                : cartItems;

        if (JSON.stringify(items) !== JSON.stringify(cartData)) {
            setCartData(items);
        }
    }, [existingItemDetails, existingCartItemDetail, cartItems, cartData]);

    // cart total calculation
    const cartTotal = cartData?.map(item => {
        return item.unitPrice * item.quantity;
    }).reduce((preVal, curVal) => {
        return preVal + curVal;
    }, 0);

    const subtotal = typeof cartTotal === 'number' ? cartTotal.toFixed(2) : '0.00';
    const totalAmount = parseFloat(subtotal) + deliveryCharge;

    useEffect(() => {
        const cartTotal = cartData?.map(item => {
            return item.unitPrice * item.quantity;
        }).reduce((preVal, curVal) => {
            return preVal + curVal;
        }, 0);

        const subtotal = typeof cartTotal === 'number' ? cartTotal.toFixed(2) : '0.00';
        const totalAmount = parseFloat(subtotal) + deliveryCharge;
        setTotalAmounts(totalAmount);

    }, [cartData, deliveryCharge]);

    useEffect(() => {
        if (loginDetailById) {
            setFormData(prevState => ({
                ...prevState,
                name: loginDetailById.name || "",
                emailId: loginDetailById.emailId || "",
                contatctNo: String(loginDetailById.mobileNo || ""),
            }));
        }
    }, [loginDetailById]);

    const fetchLognDetailById = useCallback(async () => {
        if (loginId) {
            setLoading(true);
            try {
                const response = await get(`${API_URL?.GetLoginDetailById}?pLoginDetailId=${loginId}`);
                if (response.isSuccess === 200) {
                    setLognDetailById(response?.data[0]);
                }else{
                    setLognDetailById([]);
                }
            } catch (error) {
                setLognDetailById(null);
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    const fetchStateData = useCallback(async () => {
        if (loginId) {
            setLoading(true);
            try {
                const response = await get(API_URL?.GetState);
                if (response.isSuccess === 1) {
                    setStateData(response?.data);
                }
            } catch (error) {
                setStateData([]);
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    const getUserAddressByLoginId = useCallback(async () => {
        setLoading(true);
        if (loginId) {
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                } else {
                    setUserAdderss([]);
                }
            } catch (error) {
                setUserAdderss([]);
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    useEffect(() => {
        getUserAddressByLoginId();
        fetchLognDetailById();
        fetchStateData();
    }, [getUserAddressByLoginId, fetchLognDetailById, fetchStateData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const validateEmail = (email) => {
        const isValid = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
        return isValid;
    };

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && /^[0-9]/.test(phone);
        return isValid;
    };

    const onUserDetailSave = async (e) => {
        e.preventDefault();
        setSaveloading(true);
        if (!validatePhoneNumber(formData.contatctNo)) {
            toast.error("Please enter a valid mobile number");
            return;
        }

        if (!validateEmail(formData.emailId)) {
            toast.error("Please enter a valid Email Address");
            return;
        }

        try {
            const response = await post(API_URL?.SaveUserAddress, formData);
            if (response.isSuccess === 200) {
                localStorage.setItem('selectedAddressId', response.data.addressId);
                getUserAddressByLoginId();
                setShowForm(false);
                setFormData({
                    addressId: 0,
                    loginId: 0,
                    addressTypeId: 1,
                    name: "",
                    addressLine1: "",
                    addressLine2: "",
                    landmark: "",
                    city: "",
                    stateId: 0,
                    countryId: 1,
                    pincode: "",
                    emailId: "",
                    contatctNo: "",
                    isActive: true,
                });
                navigate("/checkout");
            }
        } catch (error) {
            toast.error("Please try again.");
        } finally {
            setSaveloading(false);
        }
    };

    const handleAddressSelect = (addressId) => {
        if (addressId != null) {
            setSelectedAddressId(addressId);
            localStorage.setItem('selectedAddressId', addressId);
        }
    };

    const handleAddAddressClick = () => {
        setFormData({
            addressId: 0,
            loginId: loginId,
            addressTypeId: 1,
            name: loginDetailById.name || "",
            addressLine1: "",
            addressLine2: "",
            landmark: "",
            city: "",
            stateId: 0,
            countryId: 1,
            pincode: "",
            emailId: loginDetailById.emailId || "",
            contatctNo: String(loginDetailById.mobileNo || ""),
            isActive: true,
        });
        setShowForm(true);
    };

    const handleBackToAddresses = () => {
        setShowForm(false);
    };

    const onEdit = (item) => {
        setShowForm(true);
        setFormData({
            ...formData,
            addressId: item?.addressId,
            loginId: loginId,
            addressTypeId: 1,
            name: item?.name || "",
            addressLine1: item?.addressLine1,
            addressLine2: item?.addressLine2,
            landmark: "city",
            city: item?.city,
            stateId: item?.stateId,
            countryId: 1,
            pincode: item?.pincode,
            emailId: item?.emailId || "",
            contatctNo: String(item?.contatctNo || ""),
            isActive: true,
        })
    }

    const onCheckout = () => {
        if (!userAddress || userAddress?.length === 0) {
            alert('Please select or add an address.');
            return;
        }

        if (!selectedAddressId || selectedAddressId == null) {
            const firstAddressId = userAddress[0]?.addressId;

            if (firstAddressId) {
                localStorage.setItem('selectedAddressId', firstAddressId);
                navigate('/checkout');  // Perform the navigation
            } else {
                alert('Address ID is missing. Please select or add an address.');
            }
        } else {
            navigate('/checkout');
        }
    };

    useEffect(() => {
        dispatch(get_cart_Data());
    }, [dispatch]);

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt=""/></div>;

    return (
        <Layout>
            <section className="same_space layout_main">
                <div className="container">
                    <div className="all_page_heading">
                        <h5 className="address_description">Delivery Address</h5>
                    </div>
                    <div className="row mt-lg-4 mt-0">
                        <div className="col-xl-8 col-md-7 col-12">
                            {userAddress != null && userAddress.length > 0 && !showForm ? (
                                <UserAddress
                                    handleAddressSelect={handleAddressSelect}
                                    userAddress={userAddress}
                                    handleAddAddressClick={handleAddAddressClick}
                                    onEdit={onEdit}
                                />
                            ) : (
                                <AddressForm
                                    userAddress={userAddress}
                                    onUserDetailSave={onUserDetailSave}
                                    handleChange={handleChange}
                                    formData={formData}
                                    stateData={stateData}
                                    loading={saveloading}
                                    showForm={showForm}
                                    handleBackToAddresses={handleBackToAddresses}
                                />
                            )}
                        </div>
                        <div className="pcard d-flex justify-content-center col-xl-4 col-md-5 col-12 mb-4">
                            <Summary
                                onProccedPay={onCheckout}
                                formattedTotal={totalAmount}
                                totalAmounts={totalAmounts}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default ShippingAddress;